import React, { Component, PropTypes } from 'react';
import StoreLayoutOverviewColumn from './StoreLayoutOverviewColumn';
import { StoreOverviewActions } from 'actions';
import * as SvgIcons from 'components/Material/SvgIcons';
import { hexToRgba, Units, Colors } from 'Css';
import classNames from 'classnames';
import DropTarget from 'react-dnd/lib/DropTarget';

const css = oxygenCss({
  root: {
    position: 'relative',
    display: 'flex',
    padding: Units.base,
    borderWidth: 2,
    borderStyle: 'dashed none dashed none',
    borderColor: 'transparent',
    '&before': {
      borderTopColor: `${hexToRgba(Colors.creen, 20)}`
    },
    '&after': {
      borderBottomColor: `${hexToRgba(Colors.creen, 20)}`
    }
  },
  dragContainer: {
    transition: 'all 0.25s ease',
    boxSizing: 'border-box',
    padding: Units.base / 2,
    flex: 1,
    '&size1': {
      flex: '1 0 100%'
    },
    '&size2': {
      flex: '1 0 50%'
    },
    '&size3': {
      flex: '1 0 33%'
    },
    '&size4': {
      flex: '1 0 25%'
    },
    '>SVG': {
      verticalAlign: 'middle'
    }
  },
  drag: {
    position: 'relative',
    textAlign: 'center',
    lineHeight: `${Units.keyline}px`,
    boxSizing: 'border-box',
    height: Units.keyline,
    cursor: 'pointer',
    border: `dashed 2px ${hexToRgba(Colors.creen, 90)}`,
    backgroundColor: `${hexToRgba(Colors.creen, 25)}`,
    opacity: 0.5,
    '>SVG': {
      verticalAlign: 'middle'
    }
  }
});

const styles = {
  icon: {
    width: Units.base * 4,
    height: Units.base * 4
  }
};

const icons = {
  Text: SvgIcons.EditorFormatAlignLeft,
  Banner: SvgIcons.ImageLandscape,
  Image: SvgIcons.ImageImage,
  Video: SvgIcons.AvMovie,
  List: SvgIcons.ImageViewComfy,
  Filter: SvgIcons.ContentFilterList
};

const dropTarget = {
  hover(props, monitor, component) {
    if (monitor.isOver({ shallow: true }) && component) {
      const offset = monitor.getClientOffset();
      const { y, x } = offset;
      component.checkHover(y, x, monitor.getItem().id);
    }
  }
};

class StoreLayoutOverviewRow extends Component {
  static propTypes = {
    type: PropTypes.string,
    modules: PropTypes.array,
    selectedModule: PropTypes.object,
    connectDropTarget: PropTypes.func,
    marked: PropTypes.string,
    id: PropTypes.string
  };

  select = () => {
    const { id } = this.props;
    StoreOverviewActions.selectSection(id);
  };

  endDrag = (item, didDrop) => {
    if (didDrop) {
      StoreOverviewActions.endDragging(this.props.id, item);
    } else {
      StoreOverviewActions.resetDragging();
    }
  };

  checkHover = (y, x, moduleId) => {
    const { left, top, height, width } = this._node.getBoundingClientRect();
    const { id, modules } = this.props;
    const modulesWithoutDragging = modules.filter(
      module => module.id !== 'drag'
    );
    let { length: columnCount } = modules;
    const moduleIndex = modulesWithoutDragging.findIndex(
      module => module.id === moduleId
    );
    if (moduleIndex < 0) {
      columnCount++;
    }
    const xOffset = Math.max(x - left, 1);
    const dropPosition = Math.floor(columnCount * (xOffset / width));
    if (moduleIndex > -1 && moduleIndex === dropPosition) {
      if (modules.length !== modulesWithoutDragging.length) {
        StoreOverviewActions.resetDragging();
      }
      return;
    }
    const pos = (y - top) / height;
    if (pos < 0.33) {
      StoreOverviewActions.overSection('before', id);
    } else if (pos > 0.66) {
      StoreOverviewActions.overSection('after', id);
    } else {
      StoreOverviewActions.setDraggingPos(id, dropPosition, moduleId);
    }
  };

  render() {
    const { modules, selectedModule, marked, id } = this.props;
    const columnCount = modules.length;
    const dragClasses = classNames(
      css.dragContainer,
      css[`size${columnCount}`]
    );
    const classes = classNames(css.root, {
      [css.before]: marked === 'before',
      [css.after]: marked === 'after'
    });
    const content = (
      <div
        ref={_node => (this._node = _node)}
        className={classes}
        onTouchTap={this.select}
      >
        {modules.map(module => {
          const { id: moduleId, type, ...other } = module;
          if (type === 'Drag') {
            const Icon = icons[module.subType];
            return (
              <div className={dragClasses} key="drag">
                <div className={css.drag}>
                  <Icon style={styles.icon} color={Colors.creen} />
                </div>
              </div>
            );
          }
          return (
            <div className={dragClasses} key={moduleId}>
              <StoreLayoutOverviewColumn
                endDrag={this.endDrag}
                onHover={this.onHover}
                id={moduleId}
                sectionId={id}
                columnCount={columnCount}
                selected={selectedModule && moduleId === selectedModule.id}
                type={type}
                {...other}
              />
            </div>
          );
        })}
      </div>
    );
    return this.props.connectDropTarget(content);
  }
}

export default DropTarget('StoreColumn', dropTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver()
}))(StoreLayoutOverviewRow);



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/LayoutOverview/StoreLayoutOverviewRow.js